import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiBroeuklenRotterdamAirportPage() {
  return (
    <CityAirportTemplate
      city="Breukelen"
      airport="rotterdam"
      airportName="Rotterdam The Hague Airport"
      price={75.00}
      distance="62 km"
      duration="52-58 minuten"
    />
  );
}
